import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';

import hezuo1 from '../../static/hezuo1.webp'
import hezuo2 from '../../static/hezuo2.webp'
import hezuo3 from '../../static/hezuo3.webp'
import hezuo4 from '../../static/hezuo4.webp'


const Volunteer: React.FC = () => {
    const history = useHistory();
    const [numbers] = React.useState([
        {
            img: hezuo1,
            title: '绿城公益'
        },
        {
            img: hezuo2,
            title: '郁金香陪伴'
        },
        {
            img: hezuo3,
            title: '传善公益咨询'
        },
        {
            img: hezuo4,
            title: '河南省慈善总会'
        }
    ]);

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>合作伙伴</h1>
                <div className='partners-container'>
                    {numbers.map((partner,index) => (
                        <div key={index} className='partner-item'>
                            <img src={partner.img} alt={`合作伙伴${partner.title}`} className='partner-logo' />
                            <p className='partner-name'>{partner.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        } />
    );
};

export default Volunteer;